import { render, staticRenderFns } from "./PlanResponsiveCard.vue?vue&type=template&id=b28fad76&scoped=true"
import script from "./PlanResponsiveCard.vue?vue&type=script&lang=js"
export * from "./PlanResponsiveCard.vue?vue&type=script&lang=js"
import style0 from "./PlanResponsiveCard.vue?vue&type=style&index=0&id=b28fad76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28fad76",
  null
  
)

export default component.exports